/**
 * Anzeigeformen von Personennamen für enge Flächen (Issue #99, Board-Karten).
 * Akademische Titel („Dr.", „Prof.") werden übersprungen — sonst würde aus
 * „Dr. Katharina Oberländer-Fischer" ein „D. Katharina Oberländer-Fischer".
 */

function nameParts(name: string): string[] {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  // Führende Titel erkennt man am abschließenden Punkt.
  while (parts.length > 1 && parts[0]?.endsWith('.')) parts.shift();
  return parts;
}

/** „Maria Schneider" → „M. Schneider"; einteilige Namen bleiben unverändert. */
export function shortPersonName(name: string): string {
  const [first = '', ...rest] = nameParts(name);
  if (rest.length === 0) return first;
  return `${first[0]}. ${rest.join(' ')}`;
}

/** „Maria Schneider" → „MS"; letztes Namensteil liefert das zweite Initial. */
export function personInitials(name: string): string {
  const parts = nameParts(name);
  const first = parts[0]?.[0] ?? '';
  const last = parts.length > 1 ? (parts[parts.length - 1]?.[0] ?? '') : '';
  return `${first}${last}`.toUpperCase();
}
